import { FeatureFlagProviderName, FeatureFlagProvidersMap } from "../../components";
import { FeatureFlagStateContext } from "../../contexts";
import { useContextSafely } from "../../utils/react-utils";

/**
 * A hook that return the active user for the `UserProvider`.
 *
 * @param suppressErrorMessage Suppress console error message when the hook is used without `FeatureFLagTextProvider`.
 */
export function useFeatureFlagProviders<F extends FeatureFlagProviderName>(suppressErrorMessage?: boolean) {
  return useContextSafely<FeatureFlagProvidersMap<F>>(
    FeatureFlagStateContext,
    suppressErrorMessage,
    useFeatureFlagProviders.name
  );
}
